<template>
	<div class="sidebar-template-selection">

		<b-tabs small v-model="tabIndex" v-if="!loading">
			<b-tab :title="tagGroup.name"
			       v-for="tagGroup in tagGroups"
			       :key="tagGroup.id">
				<div class="template-list">
					<div class="_entry-wrap_"
					     v-for="template in tagGroup.templates"
						 :key="template.PKM_Template"
						 @click="handleTemplateClick(template)">
						<b-card :class="cardClasses(template)"
						        show-footer>
						    <img class="image"
						         :src="getAbsolutePathForImage(template.S_Vorschaubild_url)"
						         :alt="template.S_Titel"/>
							<small slot="footer"
							       class="text-muted"
							       :title="template.S_Template">
								<span class="_tmpl-id">{{ template.PKM_Template }}</span>
								<span class="_tmpl-name">{{ template.S_Titel }}</span>
								<!--<span class="_tmpl-path" v-html="hyph(template.S_Templatepfad)"></span>-->
								<div class="_tmpl-tags">
									<b-badge v-for="tag in template.tags.result"
									         :key="tag.PKM_Tag"
									         class="badge">
										{{ tag.S_Value }}
									</b-badge>
								</div>
							</small>
						</b-card>
					</div>
				</div>
			</b-tab>
		</b-tabs>

		<erco-cloak v-if="loading"></erco-cloak>
	</div>
</template>

<script>

	import ErcoCloak from '@/components/molecules/ErcoCloak';

	import url from 'url';

	export default {
		name: 'ErcoSidebarTemplateSelectionMolecule',
		props: {
			data: {
				type: Object,
			},
		},
		data() {
			return {
				tabIndex: 0,
				selectedTemplateId: -1,
			};
		},
		computed: {
			templates() {
				return Object.keys(this.data.items).map(key => this.data.items[key]);
			},
			tagGroups() {
				const tagGroups = {};
				const templates = this.templates;

				templates.forEach((template) => {
					const templateTagsResult = template.tags.result;

					if (Object.keys(templateTagsResult).length === 0) {
						return;
					}

					Object.keys(templateTagsResult).forEach((key) => {
						const templateTag = templateTagsResult[key];
						const tagName = templateTag.S_Value;
						const tagId = tagName.trim().toLowerCase();

						if (!tagGroups[tagId]) {
							tagGroups[tagId] = {
								id: tagId,
								name: tagName,
								templates: [],
							};
						}

						tagGroups[tagId].templates.push(template);
					});
				});

				const tagGroupsArr = Object.keys(tagGroups).map(key => tagGroups[key]);

				/* Weiteren Tab mit allen Templateeinträgen */
				tagGroupsArr.unshift({
					id: 'all',
					name: 'All',
					templates: this.templates,
				});

				return tagGroupsArr;
			},
			loading() {
				return this.data.loading;
			},
		},
		methods: {
			cardClasses(dataset) {
				const templateId = parseInt(dataset.PKM_Template, 10);
				return [
					'_entry',
					{ '-active': (templateId === this.selectedTemplateId) },
				];
			},
			getAbsolutePathForImage(imgPath) {
				return url.resolve(process.env.IMG_SERVER, imgPath);
			},
			handleTemplateClick(templateData) {
				this.selectedTemplateId = parseInt(templateData.PKM_Template, 10);

				const newSidebarValue = Object.assign({}, this.$store.state.sidebar.context);

				newSidebarValue.value.selectedTemplateId = this.selectedTemplateId;
				newSidebarValue.value.selectedTemplateData = templateData;

				this.$store.dispatch('updateSidebar', {
					context: newSidebarValue,
				});
			},
			hyph(str) {
				return str.replace(/([/-_])/g, '<wbr>$1');
			},
		},
		components: {
			ErcoCloak,
		},
	};

</script>

<style lang="scss">

.sidebar-template-selection {
	padding: 0.5rem;
	padding-top: 1.5rem;

	.template-list {
		border: 1px solid rgba(221, 221, 221, 1);
		border-top: 0;
		display: flex;
		flex-wrap: wrap;
		justify-content: flex-start;
		padding: 0.5rem;

		& > ._entry-wrap_ {
			cursor: pointer;
			margin: 0 0.4rem 1rem;
			width: 15%;

			& > ._entry {

				&.-active {
					border-color: rgba(65, 150, 65, 1);
					box-shadow: 0 0 5px rgba(65, 150, 65, 1);
				}

				& > .card-block {
					padding: 0;

					& > .image {
						width: 100%;
						min-height: 82px;
					}
				}

				& > .card-footer {
					padding: 0.2rem 0.5rem;

					._tmpl-id {
						font-size: 0.7rem;
					}

					._tmpl-name {
						display: block;
					}

					._tmpl-path {
						display: block;
					}

					._tmpl-tags {
						margin-top: 0.75rem;

						> .badge {
							font-size: 0.7rem;
							margin-right: 0.25rem;
							font-weight: normal;
						}
					}
				}
			}
		}
	}
}

</style>



// WEBPACK FOOTER //
// TemplateSelection.vue?4dcb9fbf